module.exports = __webpack_public_path__ + "static/media/1.72cb0fb3.jpg";